import type { TFunction } from 'i18next'
import type { FieldErrors } from 'react-hook-form'
import type { StrategyModalFormData } from '../model/types'

import { AnchorFamiliesTab } from '../ui/AnchorFamiliesTab'
import { AnchorSelectionTab } from '../ui/AnchorSelectionTab'
import { GeneralTab } from '../ui/GeneralTab'
import { PriceDistanceTab } from '../ui/PriceDistanceTab'

export const getStrategyModalTabs = (t: TFunction) =>
	[
		{
			key: 'general',
			label: t('anchoring_management.strategy.tab.general.title'),
			hasError: (errors: FieldErrors<StrategyModalFormData>) =>
				errors?.optimization_group_ids,
			TabContent: GeneralTab,
		},
		{
			key: 'anchor_families',
			label: t('anchoring_management.strategy.tab.anchor_families.title'),
			hasError: (errors: FieldErrors<StrategyModalFormData>) =>
				errors?.settings?.groups,
			TabContent: AnchorFamiliesTab,
		},
		{
			key: 'anchor_selection',
			label: t('anchoring_management.strategy.tab.anchor_selection.title', {
				defaultValue: 'Anchor selection',
			}),
			hasError: (errors: FieldErrors<StrategyModalFormData>) =>
				errors?.settings?.anchor_selection,
			TabContent: AnchorSelectionTab,
		},
		{
			key: 'price_distance',
			label: t('anchoring_management.strategy.tab.price_distance.title'),
			hasError: (errors: FieldErrors<StrategyModalFormData>) =>
				errors?.settings?.indexes,
			TabContent: PriceDistanceTab,
		},
	].filter(Boolean)
